<div class="col-12 md:col-12 lg:col-12 pad-btm-0px p-0">
  <div class="col-12 md:col-6 lg:col-8 bread-crumb pl-1">
    <div *ngIf="breadCrumb?.length">
      <span *ngFor="let eachRow of breadCrumb; let i = index">
        <a [title]="eachRow?.label" (click)="onClick(eachRow)">{{ eachRow?.label }}</a>
        <span *ngIf="i < (breadCrumb.length - 1)"> / </span>
      </span>
    </div>
  </div>
</div>
